import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {teacherIdState, teacherNameState} from "../../recoil/teacher/teacherIdState";
import {
    deleteHomeworkAll,
    getHomeData,
    getHomeHomeworkData,
    getHomeHomeworkFinData,
    getStudents
} from "../../network/Endpoint";
import {useEffect, useState} from "react";
import {authState} from "../../recoil/auth/authState";
import {useNavigate} from "react-router-dom";
import AddStudentBtn from "../../assets/images/add_studentBtn.png"
import BooksImg from "../../assets/images/books_ico.png"
import OpenBookImg from "../../assets/images/open_book.png"
import HomeStageBadge from "./HomeStageBadge";
import { topMenuTypeState} from "../../recoil/menuState/topMenuState";
import {mainClassState} from "../../recoil/classes/classesState";
import ShowNextBtn from "../../assets/images/show_next_btn.png"
import {gradeState, hwGradeState, hwSemesterState, semesterState} from "../../recoil/lesson/lessonState";
import HomeStageBadgeHomework from "./HomeStageBadgeHomework";
import SideMenu from "../../components/SideMenu";
import HomeTop from "./components/HomeTop";
import Filter from "../../assets/images/fillter.png"
import {homeSubMenuState} from "../../recoil/home/homeState";
import { useLoadingSpinner } from "../../components/LoadingSpinner";
import {messageToast} from "../../components/Toast";
import Modal from "../../components/Modal";
import Button from "../classStudentManagement/components/Button";
import * as React from "react";

const HomeHomeworkPage = () => {
    const auth = useRecoilValue(authState);
    const teacherId = useRecoilValue(teacherIdState);
    //const [teacherId, setTeacherId] = useState(55);
    const [mainClass, setMainClass] = useRecoilState(mainClassState);
    const [studentsCount, setStudentsCount] = useState(null);
    const [grade, setGrade] = useRecoilState(hwGradeState);
    const [semester, setSemester] = useRecoilState(hwSemesterState);
    const [totalStageSemesterCount, setTotalStageSemesterCount] = useState(null);
    const [studyActiveStageSemesterCount, setStudyActiveStageSemesterCount] = useState(null);
    const [progressSemesterRate, setProgressSemesterRate] = useState(null);
    const [homeworkIngCount, setHomeworkIngCount] = useState(null);
    const [homeworkFinCount, setHomeworkFinCount] = useState(null);
    const [completionRateIng, setCompletionRateIng] = useState(null);
    const [recentStageResults, setRecentStageResults] = useState(null);
    const navigate = useNavigate();
    const [displayCount, setDisplayCount] = useState(5); // 처음에는 5개만 표시
    const [hwListTab, setHwListTab] = useState("hwIng");
    const [finStageResults, setFinStageResults] = useState(null);
    const [finHwPage, setFinHwPage] = useState(0);
    const [homeTab, setHomeTab] = useRecoilState(homeSubMenuState);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    
    // 로딩 스피너 훅 사용
    const { isLoading, setIsLoading, LoadingIndicator } = useLoadingSpinner();
    const { isLoading: isLoadingFin, setIsLoading: setIsLoadingFin, LoadingIndicator: LoadingIndicatorFin } = useLoadingSpinner();

    const setMenuType = useSetRecoilState(topMenuTypeState);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("home");
        }
    },[setMenuType])

    const selectMenu = (selectedPath) =>{
        setMenuType(selectedPath);
        navigate("/page/"+selectedPath);
    }


    /**
     * 선택된 클래스 학생 리스트 가져오기
     * @param classId
     * @returns {Promise<void>}
     */
    const fetchHomeData = async () => {
        setIsLoading(true); // 데이터 로딩 시작
        
        try {
            const body = {
                teacherId: teacherId
            };
            const res = await getHomeHomeworkData(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const data = res.data.data;
                setStudentsCount(data.studentsCount);
                setGrade(data.grade);
                setSemester(data.semester);
                setTotalStageSemesterCount(data.totalStageSemesterCount);
                setStudyActiveStageSemesterCount(data.studyActiveStageSemesterCount);
                setProgressSemesterRate(data.progressSemesterRate);
                setHomeworkIngCount(data.homeworkIngCount);
                setHomeworkFinCount(data.homeworkFinCount);
                setCompletionRateIng(data.completionRateIng);
                setRecentStageResults(data.homeworkStageResults);
            }else if(statusCode === 'NoClass'){
                alert(`${res.data.status.message}`);
                navigate("/page/management?page=class");
            } else {
                alert(`ERROR: 학생 정보 로드중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        } finally {
            setIsLoading(false); // 데이터 로딩 완료
        }
    };

    /**
     * 종료된 숙제 불러오기
     * @param classId
     * @returns {Promise<void>}
     */
    const fetchFinHomeworkData = async (page) => {
        setIsLoadingFin(true); // 종료된 숙제 데이터 로딩 시작
        
        try {
            const body = {
                teacherId: teacherId,
                page: page,
                size: 10
            };
            const res = await getHomeHomeworkFinData(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const data = res.data.data;
                setFinStageResults(prev => [...(prev || []), ...data]);
            }else if(statusCode === 'NoClass'){
                alert(`${res.data.status.message}`);
                navigate("/page/management?page=class");
            } else {
                alert(`ERROR: 학생 정보 로드중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        } finally {
            setIsLoadingFin(false); // 데이터 로딩 완료
        }
    };

    /**
     * 숙제 일괄 취소하기
     * @param classId
     * @returns {Promise<void>}
     */
    const fetchDeleteHomeworkAll = async () => {
        try {
            const body = {
                classId: mainClass.classId
            };
            const res = await deleteHomeworkAll(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                let msgDescription = "숙제 취소가 완료되었습니다."
                messageToast({message : "숙제 취소 완료", description : msgDescription});
                fetchHomeData();    // 숙제 저장후 현 단원 숙제 정보 다시 가져와서 갱신하기
            } else {
                alert(`ERROR: 숙제 취소중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`ERROR: 숙제 취소중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${error}`);
        } finally {
            setIsLoadingFin(false); // 데이터 로딩 완료
        }
    };

    const handleDeleteStudent = () => {
        fetchDeleteHomeworkAll();
        setIsDeleteModalOpen(false);
    };

    useEffect(() => {
        if(teacherId&& mainClass){
            fetchHomeData();
        }
    }, [teacherId, mainClass]);

    const selectHwListTab = (tab) => {
        setHwListTab(tab);
        if (tab === "hwFin" && finStageResults === null) {
            fetchFinHomeworkData(finHwPage);
            setFinHwPage(finHwPage+1);
        }
    };

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            {/* 로딩 스피너 */}
            {LoadingIndicator}
            {LoadingIndicatorFin}
            
            <div className="flex flex-col items-center justify-center w-full mt-[72px] gap-[9px]">
                <HomeTop
                    auth={auth}
                    mainClass={mainClass}
                    studentsCount={studentsCount}
                    selectMenu={selectMenu}
                    homeTab="homework"
                    setHomeTab={setHomeTab}
                />
                <div className="max-w-[1044px] w-full mt-8">
                    <div className="flex flex-row justify-start items-end gap-[6px]">
                        <div className="text-[#50555F] text-[24px] font-[700]">
                            숙제 진도율
                        </div>
                        <div className="text-[#868E9F] text-[16px] font-[500]">
                            (해당 학기에서 전송한 숙제 비율)
                        </div>
                    </div>

                    <div
                        className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                        <div
                            className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-[135px]">
                            {grade}학년 {semester}학기
                        </div>
                        <div
                            className="flex items-center w-full bg-[#EFEFEF] rounded-[10px] h-[34px]  text-center text-[#50555F] text-[14px] font-[500] relative">
                            <div className="absolute w-full text-center">
                                {studyActiveStageSemesterCount}/{totalStageSemesterCount}({progressSemesterRate}%)
                            </div>
                            <div className={`bg-[#84DBCB] h-full rounded-l-[10px]`}
                                 style={{width: `${progressSemesterRate}%`}}></div>
                        </div>
                    </div>
                </div>

                <div className="max-w-[1044px] w-full mt-8">
                    <div className="flex flex-row justify-start items-end gap-[6px]">
                        <div className="text-[#50555F] text-[24px] font-[700]">
                            숙제 현황
                        </div>
                        <div className="text-[#868E9F] text-[16px] font-[500]">
                            (현재 진행중인 숙제 현황)
                        </div>
                    </div>

                    <div
                        className="flex flex-row items-center w-full  h-[140px]  gap-5 mt-3">
                        <div
                            className="flex justify-between items-center  p-2  w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] px-[32px] py-[22px]">
                            <img
                                src={BooksImg}
                                alt="books img"
                                className="w-[100px]"
                            />
                            <div className="flex flex-col justify-end h-[100px]">
                                <div
                                    className="text-[#355BDF] text-[50px] font-[700] w-[130px] h-full text-right">{homeworkIngCount}<span
                                    className="text-[40px]">개</span></div>
                                <div className="text-black text-[22px] font-[700] w-[130px] h-full text-right">숙제 진행 개수
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex justify-between items-center  p-2 w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] px-[32px] py-[22px]">
                            <img
                                src={OpenBookImg}
                                alt="memo img"
                                className="w-[100px]"
                            />
                            <div className="flex flex-col justify-end h-[100px]">
                                <div
                                    className="text-[#355BDF] text-[50px] font-[700] w-[130px] h-full text-right">{completionRateIng}<span
                                    className="text-[40px]">%</span></div>
                                <div className="text-black text-[22px] font-[700] w-[130px] h-full text-right">숙제 완료율
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-[1044px] w-full mt-8 mb-40">
                    <div className="flex flex-row justify-between items-center gap-[6px] mb-[12px]">
                        <div className="flex flex-row justify-center items-center gap-[6px] min-h-[44px]">
                            <div className="text-[#50555F] text-[24px] font-[700]">
                                최근 숙제 내역
                            </div>
                            <div className="text-[16px] text-[#868E9F] font-[500]">
                                {hwListTab === "hwIng" ? "(현재 진행중인 숙제 내역)" : "(최근 2주동안 종료된 숙제 내역)"}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row justify-between items-center gap-[6px] mb-[12px]">
                        <div className="w-[100px]"></div>
                        <div className="flex flex-row items-center justify-center gap-3  ">
                            <div className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px] bg-white font-[700] 
                                ${hwListTab === "hwIng" ? ("text-[#355BDF] border-[#7494FF]") : ("text-[#50555F66] border-[#D5D9E3]")}`}
                                 onClick={() => selectHwListTab("hwIng")}>
                                <div className="flex">진행중 숙제</div>
                                <div className="flex w-[40px] justify-center items-center">{homeworkIngCount}</div>
                            </div>
                            <div
                                className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px] bg-white font-[700] 
                                ${hwListTab === "hwFin" ? ("text-[#355BDF] border-[#7494FF]") : ("text-[#50555F66] border-[#D5D9E3]")}`}
                                onClick={() => selectHwListTab("hwFin")}>
                                <div className="">종료된 숙제</div>
                                <div className="flex w-[40px] justify-center items-center">{homeworkFinCount}</div>
                            </div>
                        </div>
                        {hwListTab === "hwIng" && homeworkIngCount>0 &&(
                            <div className="w-[100px] h-[29px] bg-[#7494FF] rounded-[7px] flex justify-center items-center text-center text-[#fff] text-[14px] font-[700] cursor-pointer"
                                onClick={() => setIsDeleteModalOpen(true)}
                            >
                                숙제 일괄 취소
                            </div>
                        )}
                        {(hwListTab === "hwFin" ||  homeworkIngCount < 1) &&(
                            <div className="w-[100px]"></div>
                        )}
                    </div>
                    {hwListTab === "hwIng" ? (
                        recentStageResults && recentStageResults.length > 0 ? (
                                <>
                                    {recentStageResults.slice(0, displayCount).map((result, index) => (
                                        <HomeStageBadgeHomework
                                            key={index}
                                            grade={grade}
                                            semester={semester}
                                            stageSummary={result}
                                            classInfo={mainClass}
                                            fetchGetClassHomework={fetchHomeData}
                                        />
                                    ))}

                                    {/* 더보기 버튼: 표시된 개수(displayCount)가 전체 개수보다 적을 경우만 표시 */}
                                    {displayCount < recentStageResults.length && (
                                        <button
                                            onClick={() => setDisplayCount(displayCount + 5)}
                                        >
                                            <img src={ShowNextBtn}
                                                 alt="show next btn"/>
                                        </button>
                                    )}
                                </>
                            )
                            :
                            (
                                <>
                                    <div
                                        className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                        <div
                                            className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                            진행중인 숙제가 없습니다.
                                        </div>
                                    </div>
                                </>
                            )
                    ) : (
                        finStageResults && finStageResults.length > 0 ? (
                            <>
                                {finStageResults.map((result, index) => (
                                    <HomeStageBadgeHomework
                                        key={index}
                                        grade={grade}
                                        semester={semester}
                                        stageSummary={result}
                                        classInfo={mainClass}
                                        fetchGetClassHomework={fetchHomeData}
                                    />
                                ))}

                                <button onClick={() => {
                                    fetchFinHomeworkData(finHwPage);
                                    setFinHwPage(finHwPage + 1);
                                }}>
                                    {finStageResults.length < homeworkFinCount && <img src={ShowNextBtn} alt="더보기 버튼"/>}
                                </button>
                            </>
                        ) : (
                            <div
                                className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                <div
                                    className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                    종료된 숙제가 없습니다.
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
            <SideMenu></SideMenu>
            {/* 삭제 확인 모달 */}
            <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">숙제 일괄 취소</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="my-8 text-2xl font-normal">
                    <div className="text-base w-full leading-tight">진행중인 숙제 {homeworkIngCount}개를 모두 취소 하시겠습니까? <br/><br/><span className="text-[#355BDF] ">숙제를 취소하면 해당 학습의 학습결과는 사라집니다.</span>
                    </div>
                </div>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsDeleteModalOpen(false)}
                    />
                    <Button label="삭제하기" onClick={handleDeleteStudent}/>
                </div>
            </Modal>
        </div>
    );
}

export default HomeHomeworkPage;